"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeFromLocalStorage = exports.setItemInLocalStorage = exports.getItemFromLocalStorage = void 0;
const defaultOptions = {
    serialize: JSON.stringify,
    deserialize: JSON.parse,
    // Function to revive Date objects as Dates instead of strings
    // https://stackoverflow.com/questions/15120256/json-parse-or-alternative-library-that-will-also-parse-dates/15120418#15120418
    reviver: function (key, value) {
        // let a: RegExpExecArray | null
        if (typeof value === "string") {
            const a = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
            if (a)
                return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4], +a[5], +a[6]));
        }
        return value;
    },
};
function getItemFromLocalStorage(key, defaultValue, options = defaultOptions) {
    const { reviver } = options;
    let { deserialize } = options;
    deserialize = deserialize || defaultOptions.deserialize;
    const valueInLocalStorage = window.localStorage.getItem(key);
    if (valueInLocalStorage) {
        return deserialize(valueInLocalStorage, reviver);
    }
    return typeof defaultValue === "function" ? defaultValue() : defaultValue;
}
exports.getItemFromLocalStorage = getItemFromLocalStorage;
function setItemInLocalStorage(key, defaultValue) {
    const { serialize } = defaultOptions;
    window.localStorage.setItem(key, serialize(defaultValue));
}
exports.setItemInLocalStorage = setItemInLocalStorage;
function removeFromLocalStorage(keys) {
    if (Array.isArray(keys)) {
        keys.forEach((key) => localStorage.removeItem(key));
    }
    else {
        localStorage.removeItem(keys);
    }
}
exports.removeFromLocalStorage = removeFromLocalStorage;
